import { render } from "./AposAreaMenu.vue?vue&type=template&id=0bbe3be3&scoped=true"
import script from "./AposAreaMenu.vue?vue&type=script&lang=js"
export * from "./AposAreaMenu.vue?vue&type=script&lang=js"

import "./AposAreaMenu.vue?vue&type=style&index=0&id=0bbe3be3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbe3be3"],['__file',"area/ui/apos/components/AposAreaMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bbe3be3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bbe3be3', __exports__)) {
    api.reload('0bbe3be3', __exports__)
  }
  
  module.hot.accept("./AposAreaMenu.vue?vue&type=template&id=0bbe3be3&scoped=true", () => {
    api.rerender('0bbe3be3', render)
  })

}


export default __exports__